import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import EditBtn from "../../../component/atoms/button/editBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import TableText from "../../../component/atoms/text/table/tableText";
import FileImgPreview from "../../../component/molecules/fileImgPreview";
import GoBack from "../../../component/molecules/goBack";
import Pagination from "../../../component/molecules/pagination";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import StudentModal from "../_component/studentModal";
import ConsultingApi from "../../../api/consulting.api";
import { homeUrl } from "../../../constants/url";

const ConsultingDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [consultingInfo, setConsultingInfo] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const tabList = [
    {
      title: "컨설팅 상세",
      link: `${route.consulting_detail_info}/${id}`,
      originLink: route.consulting_detail_info,
    },
    {
      title: "컨설팅 후기 관리",
      link: `${route.consulting_detail_review}/${id}`,
      originLink: route.consulting_detail_review,
    },
  ];

  useEffect(() => {
    getConsultingInfo();
  }, []);

  const getConsultingInfo = async () => {
    try {
      const response = (await ConsultingApi.getById(id)).data.data.content;

      setConsultingInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await ConsultingApi.delete(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(route.consulting_product);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 수강생 내역
  useEffect(() => {
    getStudentList();
  }, []);

  const [studentList, setStudentList] = useState([]);

  const getStudentList = async () => {
    try {
      const data = {
        page: searchParams.get("page"),
        size: pagination.size,
        consultingMerchId: id,
      };
      let responseData = (await ConsultingApi.getStudentList(data)).data.data;

      setStudentList(
        responseData.content.map((item) => {
          return {
            ...item,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
              <EditBtn
                onClick={() => {
                  navigate(route.consulting_edit + `/${id}`);
                }}
              />
            </div>
          </DetailTop>
          <TableTab02 list={tabList} style={{ marginBottom: "20px" }} />
          <DetailPage>
            <DetailPageTitle>기본 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태</DetailFormTitle>
                <DetailFormText>
                  {consultingInfo.activation ? "활성" : "비활성"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>필요서류제출 알림</DetailFormTitle>
                <DetailFormText>
                  {consultingInfo.alarmFlag ? "활성" : "비활성"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>컨설팅 금액</DetailFormTitle>
                <DetailFormText>
                  {consultingInfo.price?.toLocaleString()}원
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>총 매출액</DetailFormTitle>
                <DetailFormText>
                  {consultingInfo.totalSalePrice?.toLocaleString()}원
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>강의 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>강의명</DetailFormTitle>
                <DetailFormText>{consultingInfo.title}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  썸네일 이미지
                  <br />
                  (권장사이즈 585*373)
                </DetailFormTitle>
                <FileImgPreview
                  fileName={consultingInfo.thumbnailOriginFileName}
                  serverFileName={consultingInfo.thumbnailServerFileName}
                  imgStyle={{ width: "150px", height: "94px" }}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강의 소개</DetailFormTitle>
                <DetailFormText
                  onClick={() => {
                    window.open(
                      homeUrl + `/finlive/consulting/detail/${id}`,
                      "_blank"
                    );
                  }}
                  style={{ textDecorationLine: "underline", cursor: "pointer" }}
                >
                  미리보기
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>강사 소개</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>
                  강사 사진
                  <br />
                  (권장사이즈 380*380)
                </DetailFormTitle>
                <FileImgPreview
                  fileName={consultingInfo.instructorOriginFileName}
                  serverFileName={consultingInfo.instructorServerFileName}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강사명</DetailFormTitle>
                <DetailFormText>{consultingInfo.instructorName}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>소개글</DetailFormTitle>
                <DetailFormText>
                  {consultingInfo.instructorIntro}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>경력사항</DetailFormTitle>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {consultingInfo.career?.map((item, index) => {
                    return <DetailFormText key={index}>{item}</DetailFormText>;
                  })}
                </div>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>수강생 내역</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <Table
                style={{
                  width: 964,
                }}
              >
                <colgroup>
                  {/* 날짜/시간 */}
                  <col width="227px" />
                  {/* 아이디 */}
                  <col width="105px" />
                  {/* 이름 */}
                  <col width="366px" />
                  {/* 결제 금액 */}
                  <col width="109px" />
                  {/* 상세보기 */}
                  <col width="77px" />
                </colgroup>
                <thead>
                  <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                    <Th
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <TableText>날짜/시간</TableText>
                    </Th>
                    <Th>
                      <TableText>아이디</TableText>
                    </Th>
                    <Th>
                      <TableText>이름</TableText>
                    </Th>
                    <Th>
                      <TableText>결제 금액</TableText>
                    </Th>
                    <Th>
                      <TableText>상세보기</TableText>
                    </Th>
                  </Tr>
                </thead>
                <tbody>
                  {studentList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        style={{ height: "59px", background: "#fff" }}
                      >
                        <Td
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <TableText>
                            {moment(item.createdAt).format(
                              "YYYY/MM/DD HH:mm:ss"
                            )}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText>{item.member?.account}</TableText>
                        </Td>
                        <Td>
                          <TableText>{item.member?.name}</TableText>
                        </Td>
                        <Td>
                          <TableText>
                            {item.payment?.realPay.toLocaleString()}원
                          </TableText>
                        </Td>
                        <Td>
                          <DetailBtn
                            onClick={() => {
                              setSelectedData(item);
                              setDetailModalOpen(true);
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
              <Pagination
                route={route.consulting_detail_info + `/${id}`}
                queryString={""}
                currentPage={page}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? (
        <StudentModal data={selectedData} setModalOpen={setDetailModalOpen} />
      ) : (
        ""
      )}
    </>
  );
};

export default ConsultingDetail;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
